export default __webpack_public_path__ + "assets/images/change-all-cards-icon.7f68111a9ee21ca59fafb77ab66f5dd0.svg";